import {pageInfo,getDeviceAttribute} from './../api';
import {Message} from 'element-ui';
import {plant} from "../../../../api";

const interfaceLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    attributeTotal:0,
    attributePageResp:null,


    plantObj: [],
    plantAreaObj: [],
    exportObj: []
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    GET_DEVICE_ATTRIBUTE(state, data) {
      state.attributeTotal = data.total;
      state.attributePageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/md/deviceAttribute/store/deviceAttribute.store.js